import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["row", "description", "status", "addButton"]
  static values = { draftUrl: String }
  connect() { this.refreshAddButton() }
  add() {
    const row = this.rowTargets.find(row => row.hidden)
    if (row) {
      row.hidden = false
      row.querySelector("select")?.focus()
    }
    this.refreshAddButton()
  }
  refreshAddButton() {
    if (this.hasAddButtonTarget) this.addButtonTarget.disabled = this.rowTargets.every(row => !row.hidden)
  }
  async draft(event) {
    event.preventDefault()
    const button = event.currentTarget
    button.disabled = true
    this.statusTarget.textContent = "Drafting rules…"
    try {
      const response = await fetch(this.draftUrlValue, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" }, body: JSON.stringify({ description: this.descriptionTarget.value }) })
      const result = response.headers.get("content-type")?.includes("application/json") ? await response.json() : {}
      if (!response.ok) throw new Error(result.error || "Could not draft rules.")
      this.rowTargets.forEach((row, index) => {
        const rule = result.rules[index] || {}
        row.hidden = index > 0 && !rule.field
        for (const field of ["field", "value", "user_id"]) row.querySelector(`[data-rule-field="${field}"]`).value = rule[field] || ""
      })
      this.refreshAddButton()
      this.statusTarget.textContent = "Draft ready. Review the rules above, then save to apply."
    } catch (error) { this.statusTarget.textContent = error.message }
    finally { button.disabled = false }
  }
}
